const priceFormatter = new Intl.NumberFormat('en-au', {
  style: 'currency',
  currency: 'AUD',
  minimumFractionDigits: 0,
});

export const formatPriceBand = (band: number) => {
  if (Number.isNaN(band)) {
    throw new Error('Price band values must be valid numbers');
  }
  if (!Number.isFinite(band)) {
    throw new Error('Price band values must be finite');
  }
  return priceFormatter.format(band);
};

const decimalPriceFormatter = new Intl.NumberFormat('en-au', {
  style: 'currency',
  currency: 'AUD',
  minimumFractionDigits: 2,
});

export const decimalFormatPriceBand = (band: number) => {
  if (Number.isNaN(band)) {
    throw new Error('Price band values must be valid numbers');
  }
  if (!Number.isFinite(band)) {
    throw new Error('Price band values must be finite');
  }
  return decimalPriceFormatter.format(band);
};
